import { render, staticRenderFns } from "./SettlementDriver.vue?vue&type=template&id=c20d804c"
import script from "./SettlementDriver.vue?vue&type=script&lang=js"
export * from "./SettlementDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports